import { firestore } from './firebase';
import { merge } from 'lodash';
import { Category } from '../pages/Accounts/Accounts.interface';

export const loadCategories = async() => {
  const db = firestore.collection('categories');
  return db.get().then(({ docs }) => {
    return docs.map((doc) => {
      return merge(doc.data(), { id: doc.id });
    }) as Category[];
  });
};
